import { MenuItem, Tax } from '@/core/models';
import { IntegerPrecisionService } from '@/core/services';

export class CartTotalCalculationRule {
	public static totalQuantity(menuItem: MenuItem | null | undefined): bigint {
		if (!menuItem) return 0n;

		return BigInt(menuItem?.cantidad ?? 0n);
	}

	/**
	 * Total de menu items agregados al carrito.
	 */
	public static calculate(menuItem: MenuItem | null | undefined): {
		subtotal: bigint;
		taxes: bigint;
		taxesExclusive: bigint;
		total: bigint;
	} {
		if (!menuItem) return { subtotal: 0n, taxes: 0n, taxesExclusive: 0n, total: 0n };

		const price = BigInt(menuItem?.price ?? 0n);

		// TO DO - POR ACOMODAR
		// TO DO - FALTA VALIDAR - SE PASAN DIFERENTES TIPOS DE PRECIOS
		const priceCash = BigInt(menuItem?.priceCash ?? 0n);
		const couponDiscount = 0n;
		const quantity = this.totalQuantity(menuItem);
		const subtotal = price * quantity;

		//Calcular descuento de cupon
		const subtotalAfterCoupon = this.calculateCoupon(subtotal, couponDiscount);

		//Calcular impuestos
		const taxes = this.calculateTaxes(menuItem, subtotalAfterCoupon);

		return {
			subtotal,
			taxes,
			taxesExclusive: taxes,
			total: subtotal + taxes,
		};
	}

	/**
	 * Calcula el descuento total de un carrito
	 */
	public static calculateCoupon(subtotal: bigint, couponDiscount: bigint = 0n): bigint {
		if (!couponDiscount) return subtotal;

		const effectiveCouponDiscount = couponDiscount > subtotal ? subtotal : couponDiscount;

		return subtotal > effectiveCouponDiscount ? subtotal - effectiveCouponDiscount : 0n;
	}

	public static calculateTaxes(menuItem: MenuItem, subtotal: bigint): bigint {
		const precisionService = new IntegerPrecisionService();
		const quantity = this.totalQuantity(menuItem);

		const taxesForAmountExclusive =
			subtotal > 0n
				? (menuItem.impuestos
						?.filter(tax => !tax.esPorcentaje)
						.reduce((acumulado: bigint, impuesto: Tax) => acumulado + BigInt(impuesto.valor ?? 0n), 0n) ?? 0n) *
					BigInt(quantity)
				: 0n;

		let taxesForPercentExclusive = 0n;

		menuItem.impuestos
			?.filter(tax => tax.esPorcentaje)
			.forEach((impuesto: Tax) => {
				const { tax } = precisionService.adjustTaxFromScaledValue(subtotal, impuesto.valor, false);
				const roundedTax = precisionService.changePrecisionToInternal(
					precisionService.toScaledStringVisual(tax),
					precisionService.visualPrecision
				);
				taxesForPercentExclusive += roundedTax;
			});

		return taxesForAmountExclusive + taxesForPercentExclusive;
	}
}
